<div align="center">
    <div role="tabpanel" id="acta_expediente">
        <fieldset id="agregar_acta_expediente">
            <div class="container">
                <div id='page1' class="contenedorFormulario  page1">
                    <div class="row divcompleto">
                        <div class="col-md-12">
                            <div>
                                <span style="float: right; clear: right;">(A.O. - 1.4.9)</span> Formulario 5.12
                                <span style="float: right; clear: right;"></span>
                            </div>
                            <br />
                            <div class="col-md-12">
                                <div class="col-md-3" align="center"><img src="../../../../assets/images/generico/logo.png"
                                        width="100px" height="80px" />
                                </div>
                                <div align="center" class="col-md-5">
                                    <h4><strong>ACTA DE OBSERVACIONES</strong></h4>
                                    <h5><strong> DIRECCION DE OBRAS</strong></h5>
                                    <h5><strong>I. MUNICIPALIDAD DE {{ nombreMuni | uppercase}}</strong></h5>
                                </div>
                                <div class="col-md-4" align="center">
                                        <table style="float: right; clear: right; width: 100%;" class="tablaSinBorde table">
                                                <tr>
                                                    <td align="left" style="width: 50%">
                                                        <strong>Solicitud N°</strong>
                                                    </td>
                                                    <td class="border" align="center"
                                                        style="width: 50%; border: 1px solid !important">{{acta.id_solicitud}}
        
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="width: 50%" align="left">
                                                        <strong>Fecha Acta</strong>
                                                    </td>
                                                    <td class="border" align="center"
                                                        style="width: 50%; border: 1px solid !important">
                                                        {{acta.fecha_acta | date:'dd/MM/yyyy'}}
        
                                                    </td>
                                                </tr>
        
        
                                            </table>
                                </div>
                            </div>
                            
                            <div class="col-md-12"><br /><br /></div>
                            <div class="col-md-12">
                                <div class="col-md-1"></div>
                                <div class="col-md-10">
                                    <table style="width: 100%;" class="tablaSinBorde table">
                                        <tr>
                                            <td align="justify" colspan="2">
                                                <strong>{{acta?.encabezado}}</strong>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-1"></div>
                            </div>
                            <div class="col-md-12">
                                <div class="col-md-1"></div>
                                <div class="col-md-10">
                                    <table style="width: 100%" class="tabledobleborde">
                                        <tr>
                                            <td align="center" style="width: 70%" colspan="2"
                                                class="tabledobleborde td fondoResaltado"><strong>
                                                    OBSERVACIONES</strong></td>
                                            <td align="right" style="width: 30%"
                                                class="tabledobleborde td fondoResaltado"><strong>ART. o NORMA
                                                    TRANSGREDIDA</strong></td>
                                        </tr>
                                        <tr *ngFor="let o of observ">
                                            <td style="width: 10%" align="center" class="tabledobleborde td">{{o.id}}
                                            </td>
                                            <td style="width:60%" align="justify" class="tabledobleborde td">
                                                <p align="justify" [innerHTML]="o.observaciones  | nl2br"></p>
                                            </td>

                                            <td style="width:40%" class="tabledobleborde td" align="center">
                                                <p [innerHTML]="o.norma | nl2br"></p>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-1"></div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <br />
                        </div>
                        <div class="col-md-12">
                            <div class="col-md-1"></div>
                            <div class="col-md-10">
                                <table class="tablaSinBorde table">
                                    <tr>
                                        <td align="left"><strong>NOTAS: </strong> </td>
                                    </tr>
                                    <tr>
                                        <td align="justify" style="width:90%">
                                            <p [innerHTML]="acta?.notas | nl2br"></p>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-md-1"></div>
                        </div>
                        <div class="col-md-12">
                            <div class="col-md-1"></div>
                            <div class="col-md-10">Las Observaciones deberán subsanarse en su totalidad para proceder a
                                una próxima revisión. Confirmar por escrito la solución de
                                cada punto de la presente acta.</div>
                            <div class="col-md-1"></div>
                        </div>
                        <div class="col-md-12">
                            <div class="col-md-1"></div>
                            <div class="col-md-10">
                                <table class="tablaSinBorde table">
                                    <tr>
                                        <td align="justify" style="width:100%">
                                            <p [innerHTML]="acta?.notas1 | nl2br"></p>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-md-1"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12" align="center">
                <button id="pdf-download-link" title="Descargar Acta" (click)="captureScreen()">Descargar Acta</button>
            </div>
        </fieldset>
    </div>
</div>